// extracted by mini-css-extract-plugin
export default {"noPaddingBottom":"CdmReviewReferences_noPaddingBottom__GOfUO"};